import { createHashHistory } from 'history';
import React from 'react'

export const history = createHashHistory();

export function getCookie(n) {
    let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
    return a ? (a[1].endsWith('%3D')?a[1].replace(/%3D/g,''):a[1]) : '';
}
export function deleteCookie(cname) {
    let d = new Date(); 
    d.setTime(d.getTime() - (1000*60*60*24)); 
    let expires = "expires=" + d.toGMTString();
    document.cookie = `${cname}=; ${expires}`;
    return getCookie(cname)?false:true;
}

export const varDump = props =>
  <div style={{ margin: '1rem 0' }}>
    <h3 style={{ fontFamily: 'monospace' }}>Result</h3>
    <pre
      style={{
        background: '#f6f8fa',
        fontSize: '.65rem',
        padding: '.5rem',
      }}
    >
      <strong>props</strong> ={' '}
      {JSON.stringify(props, null, 2)}
    </pre>
  </div>;
